module.exports = __webpack_public_path__ + "img/ico-inspeccion.51a101c3.svg";